























import Vue from 'vue'
import Component from 'vue-class-component'
import Tabs from '@/components/layout/Tabs.vue'
import Api from '@/api'
import { User } from '@/classes/User'
import { EUserPermissions } from '@zunta/configurations'
import Switcher from '@/components/Switcher.vue'

import Card from '@/components/Card.vue'
import { FacilityModule } from '@/store/modules/facility.module'
import { getModule } from 'vuex-module-decorators'

@Component({
  components: {
    Card,
    Switcher,
    Tabs
  }
})
export default class Collections extends Vue {
  facilityModuleInstance: FacilityModule = getModule(FacilityModule, this.$store)
  user: User = Api.getUser() as User
  EUserPermissions: any = EUserPermissions

  get collectionTasks () {
    return this.$store.state.resident.collectionTasks
  }

  get tabsListItems () {
    return [
      {
        key: 'management-collections-sections-today',
        value: {
          name: 'management-collections-sections-today',
          query: {
            type: 'today'
          }
        },
        content: 'Todays Tasks'
      },
      {
        key: 'management-collections-sections-all',
        value: {
          name: 'management-collections-sections-all',
          query: {
            type: 'all'
          }
        },
        content: 'All Tasks'
      },
      // this.user.hasPermissionFor(EUserPermissions.ACCESS_TO_CLAIMS) ? {
      //   key: 'management-claim-tasks',
      //   value: {
      //     name: 'management-claim-tasks'
      //   },
      //   content: 'HMO Tasks'
      // } : null,
      {
        key: 'management-collections-sections-aging',
        value: { name: 'management-collections-sections-aging' },
        content: 'Aging'
      }
      // this.user.hasPermissionFor(EUserPermissions.ACCESS_TO_CLAIMS) ? {
      //   key: 'management-collections-sections-aging-2',
      //   value: { name: 'management-collections-sections-aging-2' },
      //   content: 'Aging 2.0'
      // } : null,
      // this.user.hasPermissionFor(EUserPermissions.ACCESS_TO_CLAIMS) ? {
      //   key: 'management-collections-claims',
      //   value: { name: 'management-collections-claims' },
      //   content: 'Claims'
      // } : null
    ].filter(Boolean)
  }
}
